import React from "react";

function Support() {
  return <h1>Asistencia</h1>;
}

export default Support;
